import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CircularProgress, ToolTip } from '@esgian/esgianui';
import { useSelector } from 'react-redux';
import { getThemeMode } from '@store/features';

const DURATION_OPTIONS = [
  { label: '5D', value: 5 },
  { label: '10D', value: 10 },
  { label: '30D', value: 30 },
  { label: '60D', value: 60 },
  { label: '90D', value: 90 }
];

const VesselsMapRouteDurationSelector = ({
  selectedDays,
  onDurationChange,
  isLoading,
  enabled = false
}) => {
  const themeMode = useSelector(getThemeMode);

  const content = (
    <Box
      sx={{
        position: 'absolute',
        bottom: '16px',
        left: '70px',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 1,
        border: `0.5px solid var(--dark-mode-border-divider-default, #7B7B7B)`,
        p: 0.5
      }}>
      {DURATION_OPTIONS.map((option) => (
        <Box key={option.value} position="relative" display="flex" alignItems="center">
          <Button
            variant="text"
            size="small"
            onClick={() => onDurationChange(selectedDays === option.value ? null : option.value)}
            disabled={!enabled}
            sx={{
              minWidth: '48px',
              height: '24px',
              backgroundColor:
                selectedDays === option.value
                  ? themeMode
                    ? 'rgba(255, 255, 255, 0.2)'
                    : 'rgba(0, 0, 0, 0.1)'
                  : 'transparent',
              color: themeMode ? 'white' : 'black',
              '&:hover': {
                backgroundColor: themeMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)'
              }
            }}>
            {option.label}
          </Button>
        </Box>
      ))}
      {isLoading && (
        <CircularProgress
          size={16}
          sx={{
            position: 'absolute',
            left: '300px',
            color: themeMode ? 'white' : 'black'
          }}
        />
      )}
    </Box>
  );

  return enabled ? (
    content
  ) : (
    <ToolTip title="Available with max 150 vessels on the map" placement="top">
      <div>{content}</div>
    </ToolTip>
  );
};

VesselsMapRouteDurationSelector.propTypes = {
  selectedDays: PropTypes.number,
  onDurationChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  enabled: PropTypes.bool
};

export default VesselsMapRouteDurationSelector;
